import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { DuplicateImagePostModalComponent } from "./DuplicateImagePostModalComponent";
import { DuplicateImagePostModalUIKitComponent } from "./DuplicateImagePostModalUIKitComponent";

type DuplicateImagePostModalUIKitComponentProps = ComponentPropsWithoutRef<
  typeof DuplicateImagePostModalUIKitComponent
>;

const DuplicateImagePostModalUIKit = ModalManager.create(
  (props: DuplicateImagePostModalUIKitComponentProps) => (
    <DuplicateImagePostModalUIKitComponent {...props} />
  ),
);

type DuplicateImagePostModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof DuplicateImagePostModalComponent>,
  "open" | "onOpenChange"
>;

const DuplicateImagePostModal = ModalManager.create(
  (props: DuplicateImagePostModalComponentProps) => {
    const modal = useModal();

    return (
      <DuplicateImagePostModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useDuplicateImagePostModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const ModalComponent = isCircleV4
    ? DuplicateImagePostModal
    : DuplicateImagePostModalUIKit;

  return useModal(ModalComponent);
};
